import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from './assets/logo.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "板块选择", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0,
    style: {"width":"100%"}
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, "首页", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "时间线", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#63acb5"} }, "板块", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "sage串展示", -1)
const _hoisted_8 = {
  href: "https://www.nmbxd.com",
  target: "_blank"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "x岛", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#63acb5"} }, "板块选择", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Vue logo",
    src: _imports_0,
    style: {"width":"100%"}
  })
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "首页", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "时间线", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#63acb5"} }, "板块", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "sage串展示", -1)
const _hoisted_16 = {
  href: "http://gitea.kgnmb.com",
  target: "_blank"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "岛民hub", -1)
const _hoisted_18 = {
  href: "https://github.com/A-islander/post-backup",
  target: "_blank"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "串备份地址", -1)
const _hoisted_20 = {
  href: "https://docs.apipost.cn/preview/b58077f3ebc9caeb/6a197cc600cf6f5c",
  target: "_blank"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", null, "接口文档", -1)
const _hoisted_22 = {
  href: "https://www.nmbxd.com",
  target: "_blank"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", null, "x岛（三酱岛）", -1)
const _hoisted_24 = {
  href: "https://www.naodong.fun",
  target: "_blank"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", null, "脑洞", -1)
const _hoisted_26 = {
  href: "http://bog.ac",
  target: "_blank"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", null, "bog岛", -1)
const _hoisted_28 = {
  href: "https://huanleegao.com/t",
  target: "_blank"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", null, "欢乐恶狗岛", -1)
const _hoisted_30 = {
  href: "https://mszym.top/",
  target: "_blank"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", null, "钉幕石之音", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_house = _resolveComponent("house")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_guide = _resolveComponent("guide")!
  const _component_location = _resolveComponent("location")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_affix, { offset: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": $setup.activeIndex,
                class: "el-menu-demo",
                mode: "horizontal",
                "active-text-color": "#63acb5",
                "menu-trigger": "click"
              }, {
                default: _withCtx(() => [
                  (!$setup.mobileStatus)
                    ? (_openBlock(), _createBlock(_component_el_menu_item, {
                        key: 0,
                        index: "plate",
                        style: {"color":"#63acb5"},
                        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.mobileDrawerStatus = true))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_menu_item, {
                    index: "login",
                    style: {"color":"#63acb5"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: "/login" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($setup.cookieName), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, {
        class: _normalizeClass($setup.bodyStyle)
      }, {
        default: _withCtx(() => [
          ($setup.mobileStatus)
            ? (_openBlock(), _createBlock(_component_el_aside, {
                key: 0,
                width: "200px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu, {
                    "default-active": "2",
                    class: "el-menu-vertical-demo",
                    collapse: false
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _createVNode(_component_router_link, { to: "/home" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, {
                            index: "1",
                            style: {"color":"#63acb5"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_house)
                                ]),
                                _: 1
                              }),
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: '/plate/0/page/1' }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, {
                            index: 'plate-' + 0,
                            style: {"color":"#63acb5"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_guide)
                                ]),
                                _: 1
                              }),
                              _hoisted_5
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_sub_menu, { index: "2" }, {
                        title: _withCtx(() => [
                          _createVNode(_component_el_icon, { style: {"color":"#63acb5"} }, {
                            default: _withCtx(() => [
                              _createVNode(_component_location)
                            ]),
                            _: 1
                          }),
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plateList, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", { key: index }, [
                              _createVNode(_component_router_link, {
                                to: '/plate/' + item.id + '/page/1'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_menu_item, {
                                    index: 'plate-' + item.id,
                                    style: {"color":"#63acb5"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_guide)
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", null, _toDisplayString(item.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["index"])
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_router_link, { to: "/sageList" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_menu_item, {
                            index: "sageList",
                            style: {"color":"#63acb5"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_location)
                                ]),
                                _: 1
                              }),
                              _hoisted_7
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createElementVNode("a", _hoisted_8, [
                        _createVNode(_component_el_menu_item, {
                          index: "8",
                          style: {"color":"#63acb5"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_location)
                              ]),
                              _: 1
                            }),
                            _hoisted_9
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_view, null, {
                default: _withCtx(({ Component }) => [
                  (_openBlock(), _createBlock(_KeepAlive, { include: "plate,login" }, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                  ], 1024))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["class"])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: $setup.mobileDrawerStatus,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.mobileDrawerStatus) = $event)),
      size: "50%",
      direction: "ltr"
    }, {
      title: _withCtx(() => [
        _hoisted_10
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          "default-active": "2",
          class: "el-menu-mobile",
          collapse: false,
          style: {"border-right":"0"}
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_router_link, {
              to: "/home",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.mobileDrawerStatus = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  index: "1",
                  style: {"color":"#63acb5"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_house)
                      ]),
                      _: 1
                    }),
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: '/plate/0/page/1',
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.mobileDrawerStatus = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  index: 'plate-' + 0,
                  style: {"color":"#63acb5"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_guide)
                      ]),
                      _: 1
                    }),
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_sub_menu, { index: "2" }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, { style: {"color":"#63acb5"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_location)
                  ]),
                  _: 1
                }),
                _hoisted_14
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plateList, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createVNode(_component_router_link, {
                      to: '/plate/' + item.id + '/page/1',
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.mobileDrawerStatus = false))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_menu_item, {
                          index: 'plate-' + item.id,
                          style: {"color":"#63acb5"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_guide)
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", null, _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/sageList",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.mobileDrawerStatus = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, {
                  index: "sageList",
                  style: {"color":"#63acb5"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_location)
                      ]),
                      _: 1
                    }),
                    _hoisted_15
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("a", _hoisted_16, [
              _createVNode(_component_el_menu_item, {
                index: "3",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_17
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_18, [
              _createVNode(_component_el_menu_item, {
                index: "3",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_19
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_20, [
              _createVNode(_component_el_menu_item, {
                index: "4",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_21
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_22, [
              _createVNode(_component_el_menu_item, {
                index: "8",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_23
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_24, [
              _createVNode(_component_el_menu_item, {
                index: "5",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_25
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_26, [
              _createVNode(_component_el_menu_item, {
                index: "6",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_27
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_28, [
              _createVNode(_component_el_menu_item, {
                index: "7",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_29
                ]),
                _: 1
              })
            ]),
            _createElementVNode("a", _hoisted_30, [
              _createVNode(_component_el_menu_item, {
                index: "7",
                style: {"color":"#63acb5"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_location)
                    ]),
                    _: 1
                  }),
                  _hoisted_31
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}